/* shop/components/Order.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	select_option,
	set_data,
	set_style,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import OrderPersonal from "./OrderPersonal.svelte";
import OrderCompany from "./OrderCompany.svelte";
import StandardDelivery from "./delivery/StandardDelivery.svelte";
import ZasilkovnaDelivery from "./delivery/ZasilkovnaDelivery.svelte";

import orderStore, {
	isDeliveryAvailableForPersonalPickup,
	isDeliveryPermittedForCountry,
	getCountry,
	deliveryCountryChanged
} from "./../orderStore";

import basketStore from "./../basketStore";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[16] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[19] = list[i];
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[22] = list[i];
	return child_ctx;
}

// (49:4) {#if $orderStore.customer_type == 'PERSONAL'}
function create_if_block_5(ctx) {
	let orderpersonal;
	let current;
	orderpersonal = new OrderPersonal({});

	return {
		c() {
			create_component(orderpersonal.$$.fragment);
		},
		m(target, anchor) {
			mount_component(orderpersonal, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(orderpersonal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(orderpersonal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(orderpersonal, detaching);
		}
	};
}

// (53:4) {#if $orderStore.customer_type == 'COMPANY'}
function create_if_block_4(ctx) {
	let ordercompany;
	let current;
	ordercompany = new OrderCompany({});

	return {
		c() {
			create_component(ordercompany.$$.fragment);
		},
		m(target, anchor) {
			mount_component(ordercompany, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(ordercompany.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(ordercompany.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(ordercompany, detaching);
		}
	};
}

// (95:12) {#each countries as country}
function create_each_block_2(ctx) {
	let option;
	let t_value = /*country*/ ctx[22].name + "";
	let t;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t = text(t_value);
			option.__value = option_value_value = /*country*/ ctx[22].code;
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (103:8) {#if $deliveryCountryChanged}
function create_if_block_3(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = `${gettext("Změnili jste zemi doručení. Vyberte prosím dopravu.")}`;
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (106:8) {#if availableDeliveries.length === 0}
function create_if_block_2(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = `${gettext("Do této země momentálně nedoručujeme.")}`;
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (114:8) {:else}
function create_else_block(ctx) {
	let standarddelivery;
	let current;

	standarddelivery = new StandardDelivery({
			props: { deliveryItem: /*deliveryItem*/ ctx[19] }
		});

	return {
		c() {
			create_component(standarddelivery.$$.fragment);
		},
		m(target, anchor) {
			mount_component(standarddelivery, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const standarddelivery_changes = {};
			if (dirty & /*availableDeliveries*/ 4) standarddelivery_changes.deliveryItem = /*deliveryItem*/ ctx[19];
			standarddelivery.$set(standarddelivery_changes);
		},
		i(local) {
			if (current) return;
			transition_in(standarddelivery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(standarddelivery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(standarddelivery, detaching);
		}
	};
}

// (112:8) {#if deliveryItem.type_slug === "zasilkovna"}
function create_if_block_1(ctx) {
	let zasilkovnadelivery;
	let current;

	zasilkovnadelivery = new ZasilkovnaDelivery({
			props: { deliveryItem: /*deliveryItem*/ ctx[19] }
		});

	return {
		c() {
			create_component(zasilkovnadelivery.$$.fragment);
		},
		m(target, anchor) {
			mount_component(zasilkovnadelivery, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const zasilkovnadelivery_changes = {};
			if (dirty & /*availableDeliveries*/ 4) zasilkovnadelivery_changes.deliveryItem = /*deliveryItem*/ ctx[19];
			zasilkovnadelivery.$set(zasilkovnadelivery_changes);
		},
		i(local) {
			if (current) return;
			transition_in(zasilkovnadelivery.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(zasilkovnadelivery.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(zasilkovnadelivery, detaching);
		}
	};
}

// (111:4) {#each availableDeliveries as deliveryItem}
function create_each_block_1(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*deliveryItem*/ ctx[19].type_slug === "zasilkovna") return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (140:12) {#if paymentMethod.price}
function create_if_block(ctx) {
	let t0;
	let t1_value = /*paymentMethod*/ ctx[16].price + "";
	let t1;
	let t2;
	let t3_value = /*$basketStore*/ ctx[5].payment_currency + "";
	let t3;

	return {
		c() {
			t0 = text(": ");
			t1 = text(t1_value);
			t2 = space();
			t3 = text(t3_value);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
			insert(target, t2, anchor);
			insert(target, t3, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*paymentMethods*/ 1 && t1_value !== (t1_value = /*paymentMethod*/ ctx[16].price + "")) set_data(t1, t1_value);
			if (dirty & /*$basketStore*/ 32 && t3_value !== (t3_value = /*$basketStore*/ ctx[5].payment_currency + "")) set_data(t3, t3_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(t2);
			if (detaching) detach(t3);
		}
	};
}

// (125:4) {#each paymentMethods as paymentMethod}
function create_each_block(ctx) {
	let input;
	let input_id_value;
	let input_checked_value;
	let input_disabled_value;
	let t0;
	let label;
	let t1_value = /*paymentMethod*/ ctx[16].title + "";
	let t1;
	let t2;
	let t3;
	let label_for_value;
	let mounted;
	let dispose;

	function click_handler_2() {
		return /*click_handler_2*/ ctx[12](/*paymentMethod*/ ctx[16]);
	}

	let if_block = /*paymentMethod*/ ctx[16].price && create_if_block(ctx);

	return {
		c() {
			input = element("input");
			t0 = space();
			label = element("label");
			t1 = text(t1_value);
			t2 = space();
			if (if_block) if_block.c();
			t3 = space();
			attr(input, "type", "radio");
			attr(input, "class", "radok");
			attr(input, "id", input_id_value = "payment_method_" + /*paymentMethod*/ ctx[16].id);
			input.checked = input_checked_value = /*$orderStore*/ ctx[3].payment_title == /*paymentMethod*/ ctx[16].title;
			input.disabled = input_disabled_value = /*$orderStore*/ ctx[3].delivery_payment_methods.length > 0 && !/*$orderStore*/ ctx[3].delivery_payment_methods.includes(/*paymentMethod*/ ctx[16].id);
			attr(label, "for", label_for_value = "payment_method_" + /*paymentMethod*/ ctx[16].id);
		},
		m(target, anchor) {
			insert(target, input, anchor);
			insert(target, t0, anchor);
			insert(target, label, anchor);
			append(label, t1);
			append(label, t2);
			if (if_block) if_block.m(label, null);
			append(label, t3);

			if (!mounted) {
				dispose = listen(input, "click", click_handler_2);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*paymentMethods*/ 1 && input_id_value !== (input_id_value = "payment_method_" + /*paymentMethod*/ ctx[16].id)) {
				attr(input, "id", input_id_value);
			}

			if (dirty & /*$orderStore, paymentMethods*/ 9 && input_checked_value !== (input_checked_value = /*$orderStore*/ ctx[3].payment_title == /*paymentMethod*/ ctx[16].title)) {
				input.checked = input_checked_value;
			}

			if (dirty & /*$orderStore, paymentMethods*/ 9 && input_disabled_value !== (input_disabled_value = /*$orderStore*/ ctx[3].delivery_payment_methods.length > 0 && !/*$orderStore*/ ctx[3].delivery_payment_methods.includes(/*paymentMethod*/ ctx[16].id))) {
				input.disabled = input_disabled_value;
			}

			if (dirty & /*paymentMethods*/ 1 && t1_value !== (t1_value = /*paymentMethod*/ ctx[16].title + "")) set_data(t1, t1_value);

			if (/*paymentMethod*/ ctx[16].price) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(label, t3);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*paymentMethods*/ 1 && label_for_value !== (label_for_value = "payment_method_" + /*paymentMethod*/ ctx[16].id)) {
				attr(label, "for", label_for_value);
			}
		},
		d(detaching) {
			if (detaching) detach(input);
			if (detaching) detach(t0);
			if (detaching) detach(label);
			if (if_block) if_block.d();
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let h1;
	let t1;
	let div0;
	let t3;
	let div3;
	let section0;
	let t4;
	let t5;
	let div2;
	let section1;
	let h20;
	let t7;
	let input0;
	let input0_checked_value;
	let t8;
	let label0;
	let t10;
	let input1;
	let input1_checked_value;
	let t11;
	let label1;
	let t13;
	let section2;
	let h21;
	let t15;
	let p;
	let label2;
	let t17;
	let select;
	let t18;
	let small;
	let t20;
	let div1;
	let t21;
	let t22;
	let t23;
	let section3;
	let h22;
	let t25;
	let t26;
	let div4;
	let input2;
	let input2_checked_value;
	let t27;
	let label3;
	let t28_value = gettext("Souhlasím se") + "";
	let t28;
	let t29;
	let a;
	let t31;
	let div5;
	let input3;
	let input3_checked_value;
	let t32;
	let label4;
	let current;
	let mounted;
	let dispose;
	let if_block0 = /*$orderStore*/ ctx[3].customer_type == 'PERSONAL' && create_if_block_5(ctx);
	let if_block1 = /*$orderStore*/ ctx[3].customer_type == 'COMPANY' && create_if_block_4(ctx);
	let each_value_2 = /*countries*/ ctx[6];
	let each_blocks_2 = [];

	for (let i = 0; i < each_value_2.length; i += 1) {
		each_blocks_2[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	}

	let if_block2 = /*$deliveryCountryChanged*/ ctx[4] && create_if_block_3(ctx);
	let if_block3 = /*availableDeliveries*/ ctx[2].length === 0 && create_if_block_2(ctx);
	let each_value_1 = /*availableDeliveries*/ ctx[2];
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks_1[i], 1, 1, () => {
		each_blocks_1[i] = null;
	});

	let each_value = /*paymentMethods*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			h1 = element("h1");
			h1.textContent = `${gettext("Objednávka")}`;
			t1 = space();
			div0 = element("div");
			div0.textContent = " ";
			t3 = space();
			div3 = element("div");
			section0 = element("section");
			if (if_block0) if_block0.c();
			t4 = space();
			if (if_block1) if_block1.c();
			t5 = space();
			div2 = element("div");
			section1 = element("section");
			h20 = element("h2");
			h20.textContent = `${gettext("Subjekt")}`;
			t7 = space();
			input0 = element("input");
			t8 = space();
			label0 = element("label");
			label0.textContent = `${gettext("Soukromá osoba")}`;
			t10 = space();
			input1 = element("input");
			t11 = space();
			label1 = element("label");
			label1.textContent = `${gettext("Firma")}`;
			t13 = space();
			section2 = element("section");
			h21 = element("h2");
			h21.textContent = `${gettext("Doprava")}`;
			t15 = space();
			p = element("p");
			label2 = element("label");
			label2.textContent = `${gettext("Země doručení")}`;
			t17 = space();
			select = element("select");

			for (let i = 0; i < each_blocks_2.length; i += 1) {
				each_blocks_2[i].c();
			}

			t18 = space();
			small = element("small");
			small.textContent = `${gettext("Možnosti a cena dopravy závisí na zemi doručení.")}`;
			t20 = space();
			div1 = element("div");
			if (if_block2) if_block2.c();
			t21 = space();
			if (if_block3) if_block3.c();
			t22 = space();

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t23 = space();
			section3 = element("section");
			h22 = element("h2");
			h22.textContent = `${gettext("Platba")}`;
			t25 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t26 = space();
			div4 = element("div");
			input2 = element("input");
			t27 = space();
			label3 = element("label");
			t28 = text(t28_value);
			t29 = space();
			a = element("a");
			a.textContent = `${gettext("všeobecnými obchodními podmínkami a zpracováním osobních údajů")}`;
			t31 = space();
			div5 = element("div");
			input3 = element("input");
			t32 = space();
			label4 = element("label");
			label4.textContent = `${gettext("Souhlasím s uložením svých kontaktních údajů do databáze KHER pro účely občasného informování o novinkách")}`;
			attr(div0, "class", "basketInfoEmpty");
			attr(section0, "class", "basketOrderPerson");
			attr(input0, "type", "radio");
			attr(input0, "class", "radok");
			attr(input0, "id", "customer_type_personal");
			input0.checked = input0_checked_value = /*$orderStore*/ ctx[3].customer_type == 'PERSONAL';
			attr(label0, "for", "customer_type_personal");
			attr(input1, "type", "radio");
			attr(input1, "class", "radok");
			attr(input1, "id", "customer_type_company");
			input1.checked = input1_checked_value = /*$orderStore*/ ctx[3].customer_type == 'COMPANY';
			attr(label1, "for", "customer_type_company");
			attr(label2, "for", "shipping_country");
			attr(select, "id", "shipping_country");
			select.required = true;
			attr(select, "aria-describedby", "shipping_country_hint");
			set_style(select, "border", "1px solid #ccc");
			set_style(select, "padding", "6px");
			set_style(select, "border-radius", "25px");
			attr(small, "id", "shipping_country_hint");
			attr(div1, "aria-live", "polite");
			attr(div1, "role", "status");
			attr(div2, "class", "basketOrderPayment");
			attr(div3, "class", "basketOrder");
			attr(input2, "type", "checkbox");
			attr(input2, "class", "checkok");
			attr(input2, "id", "terms_and_conditions_consent");
			input2.required = true;
			input2.checked = input2_checked_value = /*$orderStore*/ ctx[3].terms_and_conditions_consent;
			input2.value = "true";
			attr(a, "href", "/obchodni-podminky/");
			attr(a, "target", "_blank");
			attr(label3, "for", "terms_and_conditions_consent");
			attr(div4, "class", "basketButtonWrap");
			attr(input3, "type", "checkbox");
			attr(input3, "class", "checkok");
			attr(input3, "id", "sending_newsletters_consent");
			input3.checked = input3_checked_value = /*$orderStore*/ ctx[3].sending_newsletters_consent;
			input3.value = "true";
			attr(label4, "for", "sending_newsletters_consent");
			attr(div5, "class", "basketButtonWrap");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			insert(target, t1, anchor);
			insert(target, div0, anchor);
			insert(target, t3, anchor);
			insert(target, div3, anchor);
			append(div3, section0);
			if (if_block0) if_block0.m(section0, null);
			append(section0, t4);
			if (if_block1) if_block1.m(section0, null);
			append(div3, t5);
			append(div3, div2);
			append(div2, section1);
			append(section1, h20);
			append(section1, t7);
			append(section1, input0);
			append(section1, t8);
			append(section1, label0);
			append(section1, t10);
			append(section1, input1);
			append(section1, t11);
			append(section1, label1);
			append(div2, t13);
			append(div2, section2);
			append(section2, h21);
			append(section2, t15);
			append(section2, p);
			append(p, label2);
			append(p, t17);
			append(p, select);

			for (let i = 0; i < each_blocks_2.length; i += 1) {
				if (each_blocks_2[i]) {
					each_blocks_2[i].m(select, null);
				}
			}

			select_option(select, /*$getCountry*/ ctx[1]);
			append(p, t18);
			append(p, small);
			append(section2, t20);
			append(section2, div1);
			if (if_block2) if_block2.m(div1, null);
			append(div1, t21);
			if (if_block3) if_block3.m(div1, null);
			append(section2, t22);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				if (each_blocks_1[i]) {
					each_blocks_1[i].m(section2, null);
				}
			}

			append(div2, t23);
			append(div2, section3);
			append(section3, h22);
			append(section3, t25);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(section3, null);
				}
			}

			insert(target, t26, anchor);
			insert(target, div4, anchor);
			append(div4, input2);
			append(div4, t27);
			append(div4, label3);
			append(label3, t28);
			append(label3, t29);
			append(label3, a);
			insert(target, t31, anchor);
			insert(target, div5, anchor);
			append(div5, input3);
			append(div5, t32);
			append(div5, label4);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input0, "click", /*click_handler*/ ctx[9]),
					listen(input1, "click", /*click_handler_1*/ ctx[10]),
					listen(select, "change", /*change_handler*/ ctx[11]),
					listen(input2, "change", /*change_handler_1*/ ctx[13]),
					listen(input3, "change", /*change_handler_2*/ ctx[14])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*$orderStore*/ ctx[3].customer_type == 'PERSONAL') {
				if (if_block0) {
					if (dirty & /*$orderStore*/ 8) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_5(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(section0, t4);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*$orderStore*/ ctx[3].customer_type == 'COMPANY') {
				if (if_block1) {
					if (dirty & /*$orderStore*/ 8) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_4(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(section0, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (!current || dirty & /*$orderStore*/ 8 && input0_checked_value !== (input0_checked_value = /*$orderStore*/ ctx[3].customer_type == 'PERSONAL')) {
				input0.checked = input0_checked_value;
			}

			if (!current || dirty & /*$orderStore*/ 8 && input1_checked_value !== (input1_checked_value = /*$orderStore*/ ctx[3].customer_type == 'COMPANY')) {
				input1.checked = input1_checked_value;
			}

			if (dirty & /*countries*/ 64) {
				each_value_2 = /*countries*/ ctx[6];
				let i;

				for (i = 0; i < each_value_2.length; i += 1) {
					const child_ctx = get_each_context_2(ctx, each_value_2, i);

					if (each_blocks_2[i]) {
						each_blocks_2[i].p(child_ctx, dirty);
					} else {
						each_blocks_2[i] = create_each_block_2(child_ctx);
						each_blocks_2[i].c();
						each_blocks_2[i].m(select, null);
					}
				}

				for (; i < each_blocks_2.length; i += 1) {
					each_blocks_2[i].d(1);
				}

				each_blocks_2.length = each_value_2.length;
			}

			if (!current || dirty & /*$getCountry, countries*/ 66) {
				select_option(select, /*$getCountry*/ ctx[1]);
			}

			if (/*$deliveryCountryChanged*/ ctx[4]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_3(ctx);
					if_block2.c();
					if_block2.m(div1, t21);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (/*availableDeliveries*/ ctx[2].length === 0) {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_2(ctx);
					if_block3.c();
					if_block3.m(div1, null);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (dirty & /*availableDeliveries*/ 4) {
				each_value_1 = /*availableDeliveries*/ ctx[2];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
						transition_in(each_blocks_1[i], 1);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						transition_in(each_blocks_1[i], 1);
						each_blocks_1[i].m(section2, null);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks_1.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (dirty & /*paymentMethods, $basketStore, $orderStore, orderStore*/ 41) {
				each_value = /*paymentMethods*/ ctx[0];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(section3, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (!current || dirty & /*$orderStore*/ 8 && input2_checked_value !== (input2_checked_value = /*$orderStore*/ ctx[3].terms_and_conditions_consent)) {
				input2.checked = input2_checked_value;
			}

			if (!current || dirty & /*$orderStore*/ 8 && input3_checked_value !== (input3_checked_value = /*$orderStore*/ ctx[3].sending_newsletters_consent)) {
				input3.checked = input3_checked_value;
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks_1[i]);
			}

			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			each_blocks_1 = each_blocks_1.filter(Boolean);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				transition_out(each_blocks_1[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			if (detaching) detach(div0);
			if (detaching) detach(t3);
			if (detaching) detach(div3);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			destroy_each(each_blocks_2, detaching);
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			destroy_each(each_blocks_1, detaching);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t26);
			if (detaching) detach(div4);
			if (detaching) detach(t31);
			if (detaching) detach(div5);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let availableDeliveries;
	let $orderStore;
	let $getCountry;
	let $deliveryCountryChanged;
	let $basketStore;
	component_subscribe($$self, orderStore, $$value => $$invalidate(3, $orderStore = $$value));
	component_subscribe($$self, getCountry, $$value => $$invalidate(1, $getCountry = $$value));
	component_subscribe($$self, deliveryCountryChanged, $$value => $$invalidate(4, $deliveryCountryChanged = $$value));
	component_subscribe($$self, basketStore, $$value => $$invalidate(5, $basketStore = $$value));
	let { delivery } = $$props;
	let { paymentMethods } = $$props;

	// ziskani dat z HTML
	const dataElm = document.getElementById("svelteCountries");

	const countries = JSON.parse(dataElm.dataset.svelteCountries);

	const setDeliveryCountry = country => {
		orderStore.setProp(
			$orderStore.customer_type === 'COMPANY'
			? 'delivery_address_country'
			: 'address_country',
			country
		);
	};

	const click_handler = () => orderStore.setProp('customer_type', 'PERSONAL');
	const click_handler_1 = () => orderStore.setProp('customer_type', 'COMPANY');
	const change_handler = e => setDeliveryCountry(e.target.value);

	const click_handler_2 = paymentMethod => {
		orderStore.setProp('payment_title', paymentMethod.title);
		orderStore.setProp('payment_method_type', paymentMethod.type);
		orderStore.setProp('price_payment', paymentMethod.price);
	};

	const change_handler_1 = e => {
		orderStore.setProp('terms_and_conditions_consent', e.target.checked);
	};

	const change_handler_2 = e => {
		orderStore.setProp('sending_newsletters_consent', e.target.checked);
	};

	$$self.$$set = $$props => {
		if ('delivery' in $$props) $$invalidate(8, delivery = $$props.delivery);
		if ('paymentMethods' in $$props) $$invalidate(0, paymentMethods = $$props.paymentMethods);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*delivery, $getCountry*/ 258) {
			$: $$invalidate(2, availableDeliveries = delivery.filter(item => isDeliveryPermittedForCountry(item.countries, $getCountry)));
		}
	};

	return [
		paymentMethods,
		$getCountry,
		availableDeliveries,
		$orderStore,
		$deliveryCountryChanged,
		$basketStore,
		countries,
		setDeliveryCountry,
		delivery,
		click_handler,
		click_handler_1,
		change_handler,
		click_handler_2,
		change_handler_1,
		change_handler_2
	];
}

class Order extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { delivery: 8, paymentMethods: 0 });
	}
}

export default Order;